import { authorizedAPIClient } from './BaseRepository';

const getSlabPrediction = (salesData) => {
  return authorizedAPIClient.post(`/_predict`, salesData);
};

export { getSlabPrediction };
